export class UpdateReservationPhoneNumberBadRequestTransactionsError extends Error {
  static create(errorMessage) {
    return new UpdateReservationPhoneNumberBadRequestTransactionsError(errorMessage)
  }
}
